'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ARROWDOWNINFO = exports.ARROWDOWNINFO = 'arrowdowninfo';
var OK = exports.OK = 'ok';
var INFO = exports.INFO = 'info';
var ERROR = exports.ERROR = 'error';